import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

import { default as OldContingent } from './contingent';
/**
 * Category.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Contingent extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId, chartId, inventoryId = null }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Contingent][getAll] organizationId is mandatory`);
        }

        // If we have an inventoryId we should have an event Id
        if (inventoryId) {
            if (!eventId) {
                throw new ArgumentError(`[Model][Contingent][getAll] eventId is mandatory when using inventoryId`);
            }
            return `/ticket/organizations/${organizationId}/events/${eventId}/inventories/${inventoryId}/contingents`;
        }

        if (eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/contingents`;
        }

        if (!chartId) {
            throw new ArgumentError(`[Model][Contingent][getAll] You must provide one of eventId or chartId`);
        }
        return `/ticket/organizations/${organizationId}/charts/${chartId}/contingents`;
    }

    // Temporary backwards compatibility function
    static toOldModel(contingent) {
        if (contingent instanceof Array) {
            return contingent.map(scontingent => this.toOldModel(scontingent));
        }

        return new OldContingent(contingent);
    }
}
